/* ============================================================
   androidExecutor.js — Allowlisted action executor (Fasa 4)
   ============================================================
   ⛔ SATU-SATUNYA tempat aksi automation dilaksanakan. Aksi yang
   dicadang AI atau admin MESTI lalu sini. TIADA shell bebas — hanya
   aksi dalam ALLOWED_ACTIONS. Ini pagar keselamatan utama (brief user:
   "Never execute arbitrary shell commands suggested directly by an AI
   model. Use an allowlisted action executor").
   ============================================================ */

export const ALLOWED_ACTIONS = ['tap', 'swipe', 'input_text', 'keyevent', 'launch', 'wait', 'home', 'back', 'scroll'];
export const ALLOWED_KEYS = { home: '3', back: '4', enter: '66' };

export function describeAction(a) {
  if (!a) return '';
  const t = a.target || {};
  switch (a.action) {
    case 'tap':
      return t.kind === 'selector'
        ? `Tap "${t.text || t.id || t.desc || '?'}"`
        : `Tap (${t.x}, ${t.y})`;
    case 'swipe':
      return `Swipe (${t.x},${t.y})→(${t.x2},${t.y2})`;
    case 'input_text': return `Type "${String(a.value || '').slice(0, 40)}"`;
    case 'keyevent': return `Key: ${a.value}`;
    case 'home': return 'Home';
    case 'back': return 'Back';
    case 'launch': return `Launch ${a.value}`;
    case 'wait': return `Wait ${a.value || 1000}ms`;
    case 'scroll': return 'Scroll down';
    default: return a.action;
  }
}

// Cari elemen padan selector dalam dump semasa → pusat bounds.
export function resolveSelector(target, elements) {
  if (!target) return null;
  const id = String(target.id || '').trim();
  const text = String(target.text || '').trim();
  const desc = String(target.desc || '').trim();
  const el = (elements || []).find((e) => (
    (id && e.id === id) || (text && e.text === text) || (desc && e.desc === desc)
  ));
  if (!el || !el.bounds) return null;
  return { cx: (el.bounds.x1 + el.bounds.x2) / 2, cy: (el.bounds.y1 + el.bounds.y2) / 2, el };
}

// Laksana SATU aksi. controller = AndroidController; elements = dump UI semasa.
export async function executeAction(controller, action, elements) {
  if (!action || !ALLOWED_ACTIONS.includes(action.action)) {
    throw new Error(`Aksi tidak dibenarkan: ${action?.action}`);
  }
  const t = action.target || {};
  const sw = controller?.info?.screenWidth || 720;
  const sh = controller?.info?.screenHeight || 1280;

  switch (action.action) {
    case 'tap':
      if (t.kind === 'selector') {
        const r = resolveSelector(t, elements);
        if (!r) throw new Error(`Elemen untuk tap tak dijumpai pada skrin (${t.id || t.text || t.desc || '?'}).`);
        return controller.tap(r.cx, r.cy);
      }
      return controller.tap(t.x, t.y);

    case 'swipe':
      if (t.kind === 'selector') {
        const r = resolveSelector(t, elements);
        if (!r) throw new Error('Elemen untuk swipe tak dijumpai.');
        return controller.swipe(r.cx, r.cy, r.cx, r.cy - 300, 300);
      }
      return controller.swipe(t.x, t.y, t.x2, t.y2, Number(action.durationMs) || 300);

    case 'input_text': return controller.inputText(action.value || '');

    case 'keyevent': {
      const v = String(action.value || '').toLowerCase();
      if (v === 'home') return controller.home();
      if (v === 'back') return controller.back();
      const code = ALLOWED_KEYS[v] || (/^\d+$/.test(action.value) ? String(action.value) : null);
      if (!code) throw new Error(`Keyevent tidak dibenarkan: ${action.value}`);
      return controller._run(['input', 'keyevent', code], `Key ${v || code}`);
    }

    case 'home': return controller.home();
    case 'back': return controller.back();
    case 'launch': return controller.launchApp(action.value);
    case 'wait': return new Promise((res) => setTimeout(res, Math.min(10000, Number(action.value) || 1000)));
    case 'scroll': return controller.swipe(sw / 2, sh * 0.7, sw / 2, sh * 0.3, 300);
    default: throw new Error(`Aksi tidak disokong: ${action.action}`);
  }
}
